












import { Component, Vue, Prop } from 'vue-property-decorator';

interface IPrice {
  priceDiscount?: number;
  price?: number;
}

@Component({
  name: 'catalog-item-price',
})
export default class Clients extends Vue {
  @Prop(Object) price!: IPrice;

  @Prop(Number) quantity!: number;

  get currentPrice() {
    return (this.price.priceDiscount || this.price.price || 0) * (this.quantity || 1);
  }

  get priceBefore() {
    return (this.price.price || 0) * (this.quantity || 1);
  }
}
